import EthStore from "stores/EthStore";
import { observable, action, runInAction, autorun } from "mobx";
import { getPriceAgainst, getUNIPrice } from "helpers/money";
import { tokens } from "eth/contracts/contracts";
import getPricingFor from "helpers/coingecko";

class Prices {
  @observable prices: Map<string, number> = new Map();

  lastTimeFetched: number | null = 0;

  constructor() {
    if (localStorage) {
      const pricesCache = localStorage.getItem("ygy-prices");
      const lastTimeFetched = localStorage.getItem("ygy-prices-fetched");

      if (pricesCache && lastTimeFetched) {
        const prices = JSON.parse(pricesCache);
        this.lastTimeFetched = parseInt(JSON.parse(lastTimeFetched));
        this.prices = new Map(Object.entries(prices));
      } else {
        this.lastTimeFetched = null;
      }
      autorun(this.syncToStorage);
    }
  }

  canFetch = () => !this.lastTimeFetched || this.lastTimeFetched + 30000 < Date.now();

  syncToStorage = () => {
    if (localStorage) {
      localStorage.setItem("ygy-prices", JSON.stringify(this.prices));
    }
  };

  @action fetchPrices = async (provider: any) => {
    console.log("Checking if we need to fetch prices");
    if (this.canFetch() && EthStore.network === "homestead") {
      console.log("Fetching prices");
      // Make the query
      const result: any[] = await getPricingFor(
        tokens.homestead.map((token) => token.address + ","),
        true
      );
      for (const [key, value] of Object.entries(result)) {
        tokens.homestead.forEach((token) => {
          if (token.address === key.toLowerCase()) {
            runInAction(() => this.prices.set(token.name, value.usd));
          }
        });
      }

      const RAM = tokens.homestead.find((token) => token.name === "RAM");
      const YGY = tokens.homestead.find((token) => token.name === "YGY");
      const YGYRAM = tokens.homestead.find((token) => token.name === "YGY/RAM");
      const RAMPrice = await getPriceAgainst(RAM, YGY, YGYRAM, provider);
      runInAction(() => this.prices.set("RAM", RAMPrice));
      const YGYPRICE = await getPriceAgainst(YGY, RAM, YGYRAM, provider);
      runInAction(() => this.prices.set("YGY", YGYPRICE));

      const YGYRAMPrice = await getUNIPrice(YGYRAM, YGY, provider);
      runInAction(() => this.prices.set("YGY/RAM", YGYRAMPrice));

      this.lastTimeFetched = Date.now();
      if (localStorage) {
        localStorage.setItem("ygy-prices-fetched", JSON.stringify(this.lastTimeFetched));
      }
    } else {
      console.log("Price cache hit");
    }
  };
}

export default new Prices();
